import { FileService } from "src/utils/file.service"

export function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}

export function shouldFetchIntegrations(integrations) {
  let resource = integrations;

  if (!resource.items) {
    return true;
  } else if (resource.loading) {
    return false;
  } else {
    return resource.invalidated;
  }
}

export const canRecordAssetView = (asset) => {
  if (!asset) {
    return;
  }
  var fileType = FileService.fileType(asset.metadata);

  switch (fileType) {
    case "VIDEO":
    case "YOUTUBE":
    case "VIMEO":
    case "WISTIA":
    case "AUDIO":
      return false;
    default:
      return true;
  }
};
